import AccountCreation from './AccountCreation';
import SupportedDataSources from './SupportedDataSources';
import CreatingCampaign from './CreatingCampaign';
import ConfiguringExcelCSV from './ConfigureCsvExcel';
import ConfiguringGoogleSheets from './ConfigureGoogleSheets';
import ConfiguringAirtable from './ConfigureAirtable';
import SelectingConfiguringAction from './SelectingConfiguringAction';
import EmailSetup from './EmailSetup';
import SMSWhatsAppSetup from './SmsWhatsappSetup';
import PreviewScheduling from './PreviewScheduling';
import CreatingManagingTemplates from './CreatingManagingTemplates';
import AddingIntegrationAccount from './AddingIntegrationAccount';
import ManagingFiles from './ManagingFiles';
import Profile from './Profile';
import DatabaseCampaigns from './DatabaseCampaigns';
import AirtableTokenHelp from './AirtableTokenHelp';
import TwilioCredentialsHelp from './TwilioCredentialsHelp';


export const sections = [
  { title: 'Account Creation', Component: AccountCreation, content: [] },
  { title: 'Supported Data Sources', Component: SupportedDataSources, content: [] },
  { title: 'Creating a Campaign', Component: CreatingCampaign, content: [] },
  { title: 'Configuring Excel/CSV', Component: ConfiguringExcelCSV, content: [] },
  { title: 'Configuring Google Sheets', Component: ConfiguringGoogleSheets, content: [] },
  { title: 'Configuring Airtable', Component: ConfiguringAirtable, content: [] },
  { title: 'Configuring an Action', Component: SelectingConfiguringAction, content: [] },
  { title: 'Email Setup', Component: EmailSetup, content: [] },
  { title: 'SMS & WhatsApp Setup', Component: SMSWhatsAppSetup, content: [] },
  { title: 'Preview & Scheduling', Component: PreviewScheduling, content: [] },
  { title: 'Creating Templates', Component: CreatingManagingTemplates, content: [] },
  { title: 'Integrating Accounts', Component: AddingIntegrationAccount, content: [] },
  { title: 'Airtable Api Key', Component: AirtableTokenHelp, content: [] },
  { title: 'Twilio Credentials', Component: TwilioCredentialsHelp, content: [] },
  { title: 'Managing Files', Component: ManagingFiles, content: [] },
  { title: 'Profile', Component: Profile, content: [] },
  { title: 'Database Campaigns', Component: DatabaseCampaigns, content: [] }
];